import { UserManager } from 'oidc-client';
import { getEnv } from 'config/enviroment';

const env = getEnv();

const config = {
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 600,
  authority: env?.OIDC_AUTHORIY,
  client_id: env?.OIDC_CLIENT,
  redirect_uri: env?.REDIRECT_URI,
  silent_redirect_uri: env,
  response_type: 'code',
  scope: `openid profile email offline_access IdentityServerApi ${env?.OIDC_CLIENT}`,
  post_logout_redirect_uri: env?.LOGOUT_REDIRECT_URI,
  client_secret: env?.CLIENT_SECRET,
};

export const userManager = new UserManager(config);
